// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__YBy30","outletWrapper":"Layout_outletWrapper__z-GeO"};